import { useEffect } from 'react';
import { useSetAtom, useAtomValue } from 'jotai';
import { isMobileAtom } from '@/jotai/atoms/userAtom';

export const useResponsive = (breakpoint: number) => {
  const setIsMobile = useSetAtom(isMobileAtom);
  const isMobile = useAtomValue(isMobileAtom);

  useEffect(() => {
    const handleResize = () => {
      const isMobileView = window.innerWidth < breakpoint;
      setIsMobile(isMobileView);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint, setIsMobile]);

  return { isMobile, setIsMobile };
};
